import React from 'react';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { CardStyled, CardTitleStyled } from './styles';

export interface ProductLineCardProps {
  pLineId: ProductLineId | 'Favorites';
  onCardClick: (e: React.SyntheticEvent<HTMLLIElement>) => void;
  icon: JSX.Element;
  label: string;
  className?: string;
}

const ProductLineCard = ({ pLineId, icon, label, className, onCardClick }: ProductLineCardProps): JSX.Element => {
  return (
    <CardStyled
      id={`product-details-li-${pLineId}`}
      className={className}
      onClick={onCardClick}
      data-product-line={pLineId}
      role="menuitem"
      tabIndex={0}
      onKeyDown={onCardClick}
    >
      {icon}
      <CardTitleStyled>{label}</CardTitleStyled>
    </CardStyled>
  );
};

export default ProductLineCard;
